class ReviewSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.js-reviews-slider');
    this.prevBtn = this.querySelector('.slider-arrow-prev');
    this.nextBtn = this.querySelector('.slider-arrow-next');
    this.swiper = null;
  }

  connectedCallback() {
    if (!this.slider) return;

    const disableSlider = this.dataset.disableSlider === 'true';

    if (disableSlider) {
      // Make sure arrows are hidden
      if (this.prevBtn) this.prevBtn.style.display = 'none';
      if (this.nextBtn) this.nextBtn.style.display = 'none';
      return;
    }

    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoHeight: true,

      navigation: {
        prevEl: this.prevBtn,
        nextEl: this.nextBtn
      },

      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 10
        }
      }
    });
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

if (!customElements.get('review-slider')) {
  customElements.define('review-slider', ReviewSlider);
}


class CustomCollection extends HTMLElement {
  constructor() {
    super();
    this.swipers = {};
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.initActiveTab();
    this.initTabs();
    this.initArrows();
  }

  initSwiper(carousel) {
    const tab = carousel.closest('[tab-content-element]');
    if (!tab) return;

    const id = tab.id;

    if (this.swipers[id]) {
      this.swipers[id].update();
      return;
    }

    this.swipers[id] = new Swiper(carousel, {
      slidesPerView: 2,        // Mobile
      spaceBetween: 10,
      loop: true,
      watchOverflow: true,
      direction: 'horizontal',
      breakpoints: {
        750: {
          slidesPerView: 4,    // Desktop
          spaceBetween: 10
        }
      }
    });
  }

  initActiveTab() {
    this.querySelectorAll('.active[tab-content-element] .product-carousel')
      .forEach(carousel => this.initSwiper(carousel));
  }

  initTabs() {
    this.querySelectorAll('[tab-button-element]').forEach(btn => {
      btn.addEventListener('click', () => this.switchTab(btn));
    });
  }

  switchTab(btn) {
    this.querySelectorAll('[tab-button-element]').forEach(t =>
      t.classList.remove('active')
    );
    this.querySelectorAll('[tab-content-element]').forEach(c =>
      c.classList.remove('active')
    );

    btn.classList.add('active');

    const target = this.querySelector('#tab-' + btn.dataset.target);
    if (!target) return;

    target.classList.add('active');

    target.querySelectorAll('.product-carousel')
      .forEach(carousel => this.initSwiper(carousel));

    target.querySelectorAll('card-product-slider')
      .forEach(slider => {
         console.log(slider, slider.constructor.name, slider.reinit);
        const savedColor = sessionStorage.getItem(
          'selectedSwatch-' + slider.dataset.section + '-' + slider.dataset.product
        );

        if (savedColor && typeof slider.applyFilter === 'function') {
          slider.applyFilter(savedColor);
        }

        slider.init();
      });

  }

  initArrows() {
    const arrows = Array.from(
        this.querySelectorAll('[prev], [next], [prev-mobile], [next-mobile]')
    ).filter(arrow => !arrow.closest('card-product-slider'));
    arrows.forEach(arrow => {
        arrow.addEventListener('click', () => {
          const dir = arrow.hasAttribute('prev') || arrow.hasAttribute('prev-mobile')
            ? 'prev'
            : 'next';
          this.move(dir);
        });
      });
  }

  move(direction) {
    const activeTab = this.querySelector('.active[tab-content-element]');
    if (!activeTab) return;

    const swiper = this.swipers[activeTab.id];
    if (!swiper) return;

    direction === 'prev' ? swiper.slidePrev() : swiper.slideNext();
  }

  disconnectedCallback() {
    Object.values(this.swipers).forEach(swiper => swiper.destroy());
  }
}

customElements.define('custom-collection', CustomCollection);

class CardProductSlider extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.slider = null;
    this.parentCollection = null;
  }

  connectedCallback() {
    if (this.swiper) return;

    this.slider = this.querySelector('.swiper');
    if (!this.slider) return;

    this.parentCollection = this.closest('custom-collection');
    this.init();
  }

  init() {
    this.destroy();
    this.initSwiper();
    this.initArrows();
    this.onChange();
  }

  updatePaginationGroups() {
    const bullets = this.querySelectorAll('.swiper-pagination-bullet');
    if (!bullets.length) return;

    const groupSize = 3;
    const swiper = this.swiper;
    const activeIndex = swiper.realIndex;

    const groupStart = Math.floor(activeIndex / groupSize) * groupSize;
    const groupEnd = groupStart + groupSize;

    bullets.forEach((bullet, index) => {
      bullet.style.display =
        index >= groupStart && index < groupEnd ? 'inline-block' : 'none';
    });
  }

  applyFilter(color) {
    const slides = this.querySelectorAll('.swiper-slide-main');

    slides.forEach(slide => {
      slide.classList.toggle(
        'swiper-slide',
        slide.dataset.color === color
      );

      slide.style.display =
        slide.dataset.color === color ? '' : 'none';
    });
  }


  initSwiper() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: 1,
      loop: true,
      autoHeight: true,
      nested: true,
      direction: 'horizontal',
      observer: true,
      observeParents: true,
      touchStartPreventDefault: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      }
    });
    this.updatePaginationGroups();
  }

  onChange() {
    this.swiper.on('slideChange', () => {
      const swiper = this.swiper;
      const index = swiper.realIndex;

      this.updatePaginationGroups();

      const currentSlide = swiper.slides[swiper.activeIndex];

      let activeimage = currentSlide.querySelector('img');
      if(activeimage){
        const dataSrc = activeimage.dataset.src;
        const dataSrcset = activeimage.dataset.srcset;
        if (dataSrc && activeimage.getAttribute('src') !== dataSrc) {
          activeimage.src = dataSrc;
        }
        if (dataSrcset && activeimage.getAttribute('srcset') !== dataSrcset) {
          activeimage.srcset = dataSrcset;
        }
        activeimage.classList.add('is-loaded');
      }
    });
  }

  initArrows() {
    const prevBtn = this.querySelector('[prev]');
    const nextBtn = this.querySelector('[next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', e => {
        e.preventDefault();
        this.swiper?.slidePrev();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', e => {
        e.preventDefault();
        this.swiper?.slideNext();
      });
    }
  }

  rebuild() {
    this.init();
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  disconnectedCallback() {
    this.destroy();
  }
}

customElements.define('card-product-slider', CardProductSlider);


class CustomSwatches extends HTMLElement {
  constructor() {
    super();
    this.onInputChange = this.onInputChange.bind(this);
  }

  connectedCallback() {
    this.radios = this.querySelectorAll('input[type="radio"][data-variant-id]');
    this.radios.forEach(radio => {
      radio.addEventListener("change", this.onInputChange);
    });

    const anyRadio = this.radios[0];
    if (!anyRadio) return;

    const productId = anyRadio.getAttribute("data-product-id");
    const sectionId = anyRadio.getAttribute("data-section-id");

    const savedVariantId =
      sessionStorage.getItem(`selectedVariant-${sectionId}-${productId}`) ||
      sessionStorage.getItem(`selectedSwatch-${sectionId}-${productId}`);

    let radioToActivate = null;

    // 1️⃣ sessionStorage wins
    if (savedVariantId) {
      radioToActivate = this.querySelector(
        `input[type="radio"][data-variant-id="${savedVariantId}"]`
      );
    }

    // 2️⃣ already-checked radio in DOM
    if (!radioToActivate) {
      radioToActivate = this.querySelector(
        'input[type="radio"][data-variant-id]:checked'
      );
    }

    // 3️⃣ fallback to first radio
    if (!radioToActivate) {
      radioToActivate = this.radios[0];
      radioToActivate.checked = true;
    }

    // 🔥 ALWAYS run logic on load
    if (radioToActivate) {
      this.onInputChange({ target: radioToActivate });
    }
  }

  loadVariantData(productId, variantId) {
    const scriptTag = document.querySelector(`script[data-product-id='${productId}']`);

    if (!scriptTag) {
      console.warn(`Script tag for product ${productId} not found.`);
      return null;
    }

    const scriptContent = scriptTag.textContent;

    // Match: var variantDataMap = { ... };
    const match = scriptContent.match(/var\s+variantDataMap\s*=\s*(\{[\s\S]*?\});/);

    if (!match || !match[1]) {
      console.warn(`Could not parse variantDataMap for product ${productId}`);
      return null;
    }

    let variantMap;
    try {
      variantMap = JSON.parse(match[1]);
    } catch (err) {
      console.error(`JSON parse error for product ${productId}:`, err);
      return null;
    }

    return variantMap[variantId] || null;
  }

  getProductMediaArray(productId) {
    const script = document.querySelector(`script[data-product-id='${productId}']`);
    if (!script) return [];

    const scriptContent = script.textContent;

    const match = scriptContent.match(/var\s+productMedia\s*=\s*(\[[^\]]+\])/);
    if (!match) return [];

    try {
      const mediaArray = JSON.parse(match[1].replace(/(['"])?https?:/g, '')); // normalize protocol
      return mediaArray;
    } catch (e) {
      console.warn('Could not parse productMedia for product:', productId, e);
      return [];
    }
  }

  storeSelectedVariant(sectionId, productId, variantId) {
    sessionStorage.setItem('selectedVariant-' + sectionId + '-' + productId, variantId);
  }

  storeSelectedSwatch(sectionId, productId, variantId) {
    sessionStorage.setItem('selectedSwatch-' + sectionId + '-' + productId, variantId);
  }

  triggerDefaultVariant() {
    const firstChecked =
      this.querySelector('input[type="radio"][data-variant-id]:checked') ||
      this.querySelector('input[type="radio"][data-variant-id]');
    
    if (firstChecked) {
      this.onInputChange({ target: firstChecked });
    }
  }

  onInputChange(event) {
    const radio = event.target;

    const newVariantId = radio.getAttribute("data-variant-id");
    const newProductId = radio.getAttribute("data-product-id");
    const sectionId = radio.getAttribute("data-section-id");

    this.storeSelectedVariant(sectionId, newProductId, newVariantId);
    this.storeSelectedSwatch(sectionId, newProductId, newVariantId);

    const getVariantData = this.loadVariantData(newProductId, newVariantId);

    const productGrid = radio.closest("[card-product-grid]");
    
    const sliderElement = productGrid.querySelector('[card-product-slider]');
    const selectedColor = radio.value;

    if (sliderElement && selectedColor) {
      const allSlides = sliderElement.querySelectorAll('.swiper-slide-main');

      // console.log("allSlides", allSlides)
      allSlides.forEach(slide => {
        const slideColor = slide.getAttribute('data-color');
        if (slideColor == selectedColor) {
          slide.style.display = '';
          slide.classList.remove('non-swiper-slide');
          slide.classList.add('swiper-slide');
        } else {
          slide.style.display = 'none';
          slide.classList.add('non-swiper-slide');
          slide.classList.remove('swiper-slide');
        }
      });

      // Count visible slides
      const visibleSlides = sliderElement.querySelectorAll('.swiper-slide').length;

      const cardSlider = sliderElement.closest('card-product-slider');

      if (cardSlider && typeof cardSlider.rebuild === 'function') {
        cardSlider.rebuild();
      }

    }


    // Update product form variant ID
    const productForm = productGrid.querySelector('product-form');
    if (productForm) {
      const idElement = productForm.querySelector("[name='id']");
      if (idElement) idElement.value = newVariantId;
    }

    // Re-run active filter view after swatch change
    const filterView = document.querySelector("filter-view");
    if (filterView && typeof filterView.runActiveView === "function") {
      filterView.runActiveView();
    }
  }

}
customElements.define("custom-swatches", CustomSwatches);

function dropdownProducts() {
  const wrapper = document.querySelector('.dropdown-wrapper-custom');
  if (!wrapper) return console.warn('Dropdown wrapper not found');
  const button = wrapper.querySelector('.dropdown-button'), menu = wrapper.querySelector('#dropdownMenu');
  button.addEventListener('click', () => wrapper.classList.toggle('show'));
  document.addEventListener('click', e => { if (!wrapper.contains(e.target)) wrapper.classList.remove('show'); });
  menu.querySelectorAll('.dropdown-item').forEach(item => item.addEventListener('click', () => wrapper.classList.remove('show')));
}
dropdownProducts();


class AccordionWrapper extends HTMLElement {
  constructor() {
    super();
    this.items = this.querySelectorAll('.accordion-item');
  }

  connectedCallback() {
    this.items.forEach(item => {
      const question = item.querySelector('.accordion-question');

      question.addEventListener('click', () => {
        this.toggleItem(item);
      });
    });

    if (this.items.length > 0) {
      const firstItem = this.items[0];
      const answer = firstItem.querySelector('.accordion-answer');

      firstItem.classList.add('active');
      answer.style.maxHeight = answer.scrollHeight + 'px';
    }
  }

  toggleItem(activeItem) {
    this.items.forEach(item => {
      const answer = item.querySelector('.accordion-answer');

      if (item === activeItem) {
        if (item.classList.contains('active')) {
          // Close
          answer.style.maxHeight = null;
          item.classList.remove('active');
        } else {
          // Open
          answer.style.maxHeight = answer.scrollHeight + 'px';
          item.classList.add('active');
        }
      } else {
        // Close others
        item.classList.remove('active');
        answer.style.maxHeight = null;
      }
    });
  }
}
customElements.define('accordion-wrapper', AccordionWrapper);


document.addEventListener('DOMContentLoaded', function () {
  const swiperEl = document.querySelector('.announcement-carousel');

  if (!swiperEl) return;

  new Swiper(swiperEl, {
    loop: true,
    slidesPerView: 1,
    navigation: {
      nextEl: swiperEl.closest('.announcement-bar-wrapper').querySelector('.announcement-carousel-arrow--next'),
      prevEl: swiperEl.closest('.announcement-bar-wrapper').querySelector('.announcement-carousel-arrow--prev'),
    },
  });
});


document.addEventListener('DOMContentLoaded', function () {
  // Select all menu items
  var menuItems = document.querySelectorAll('.tr-flex-item > a');
  var menuParent = document.querySelector('.tr-nav-flex'); // use single container (not NodeList)

  menuItems.forEach(function (item) {
    item.addEventListener('click', function (e) {
      var megaMenu = this.parentElement.querySelector('.tr-mega-menu'); // Associated mega menu

      if (megaMenu) {
        e.preventDefault(); // Prevent link navigation only if it has a mega menu

        var isVisible = megaMenu.style.visibility === 'visible';

        // Hide all other mega menus
        document.querySelectorAll('.tr-mega-menu').forEach(function (menu) {
          menu.style.opacity = '0';
          menu.style.visibility = 'hidden';
        });

        // Remove "menu-open" class from parent
        menuParent.classList.remove('menu-open');

        console.log("isVisible000-0-");

        // If it was closed before → open it
        if (!isVisible) {
          megaMenu.style.opacity = '1';
          megaMenu.style.visibility = 'visible';
          menuParent.classList.add('menu-open'); // ✅ add class when open
        }
      } else {
        // Normal navigation for links without mega menus
        return true;
      }
    });
  });

  // Optional: Close mega menu if clicked outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.tr-flex-item')) {
      document.querySelectorAll('.tr-mega-menu').forEach(function (menu) {
        menu.style.opacity = '0';
        menu.style.visibility = 'hidden';
      });
      document.querySelector('.tr-nav-flex')?.classList.remove('menu-open'); // ✅ remove class when clicking outside
    }
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const heroSliders = document.querySelectorAll('.hero-slider');

  // Only run if sliders exist
  if (heroSliders.length > 0) {
    heroSliders.forEach((slider) => {
      new Swiper(slider, {
        loop: true,
        slidesPerView: 1,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true
        }
      });
    });
  }
});


// ── Shared utilities ──────────────────────────────────────────

function parseGuestTiers(raw) {
  if (!raw) return [];
  const unescaped = raw.replace(/&amp;/g, "&").replace(/&#39;/g, "'");
  return unescaped.split("||").map(seg => {
    seg = seg.trim();
    // Format: "50 || 0" — after outer split on "||", each seg is "qty  val"
    const parts = seg.split(/\s+/).filter(Boolean);
    return { qty: parseInt(parts[0]) || 0, val: parseFloat(parts[1]) || 0 };
  }).filter(t => t.qty >= 0).sort((a, b) => a.qty - b.qty);
}

function getBestTier(qty, tiers) {
  let match = tiers[0] || { qty: 0, val: 0 };
  for (const t of tiers) {
    if (qty >= t.qty) match = t;
  }
  return match;
}

function applyMargin(baseCents, marginType, marginVal) {
  if (marginType === "pct") {
    return Math.round(baseCents * (1 - marginVal / 100));
  }
  // fixed: marginVal in dollars → convert to cents
  return Math.max(0, baseCents - Math.round(marginVal * 100));
}


// ── Custom Volume Pricing ─────────────────────────────────────
class CustomVolumePricing extends HTMLElement {
  constructor() {
    super();
    this.select           = this.querySelector("[category-dropdown]");
    this.priceItems       = this.querySelectorAll(".vp-price");
    this.priceItemsSingle = this.querySelectorAll(".vp-single-price");
    this.priceItemsUnit = this.querySelectorAll(".vp-unit-price");
    this.priceItemsRun = this.querySelectorAll(".vp-run-price");
    this.textHideShow = this.querySelectorAll("[vp-text-show-hide]");
    this.priceItemsRunWrapper = this.querySelector("[vp-row-run]");
    this.priceItemsUnitWrapper = this.querySelector("[vp-row-unit]");
    this.priceSetup = this.querySelector("[vp-setup-price]");
    this.priceItemsRunLabel = this.querySelector("[vp-row-run-label]");
  }

  connectedCallback() {
    if (!this.select) return;
    this.updateDecorationPricing();
    // Liquid already rendered correct prices — only update on decoration change
    this.select.addEventListener("change", () => this.updateDecorationPricing());
  }

  getColIndex(cell) {
    return Array.from(cell.closest(".vp-row").querySelectorAll(".vp-cell")).indexOf(cell);
  }

  getQtyForCell(cell) {
    const qtyCells = this.querySelectorAll(".vp-row--quantity .vp-qty");
    return parseInt(qtyCells[this.getColIndex(cell)]?.dataset.qty || 1);
  }

  updateDecorationPricing() {
    const opt = this.select.options[this.select.selectedIndex];
    if(parseInt(opt.dataset.additionalPrice) != 0) {
      this.textHideShow.forEach(item => {
        item.classList.remove("hidden")
      });
      this.priceItemsUnitWrapper?.classList.remove("hidden");
      this.priceItemsRunWrapper?.classList.remove("hidden");
    } else {
      this.textHideShow.forEach(item => {
        item.classList.add("hidden")
      });
      this.priceItemsUnitWrapper?.classList.add("hidden");
      this.priceItemsRunWrapper?.classList.add("hidden");
    }
    const runName    = opt.value;
    const addPerQty    = parseInt(opt.dataset.additionalPrice || 0);
    const addFixed     = parseInt(opt.dataset.additional || 0);

    if(this.priceItemsRunLabel) {
      this.priceItemsRunLabel.innerHTML = `(${runName})`;
    }
    this.priceItemsSingle.forEach(item => {
      const base     = parseInt(item.dataset.singlePrice || 0);
      const qty      = this.getQtyForCell(item);
      const unit     = base + addPerQty + Math.round(addFixed / qty);
      console.log("item.dataset.preset0--0-", item.dataset.preset)
      // item.innerHTML = `${item.dataset.preset}${Shopify.formatMoney(unit, window.Money_Filter)}`;
    });

    this.priceItemsUnit.forEach(item => {
      const base     = parseInt(item.dataset.singlePrice || 0);
      const qty      = this.getQtyForCell(item);
      const unit     = base + addPerQty;
      item.innerHTML = `${item.dataset.preset}${Shopify.formatMoney(unit, window.Money_Filter)}`;
    });
    
    this.priceItemsRun.forEach(item => {
      item.innerHTML = `${item.dataset.preset}${Shopify.formatMoney(addPerQty, window.Money_Filter)}`;
    });

    this.priceItems.forEach(item => {
      const base     = parseInt(item.dataset.price || 0);
      const qty      = this.getQtyForCell(item);
      // const total    = parseInt(addFixed) + (parseInt(addPerQty) * parseInt(qty)) + (parseInt(base) * parseInt(qty));
      const total    = (parseInt(addPerQty) * parseInt(qty)) + (parseInt(base) * parseInt(qty));
      item.innerHTML = `${item.dataset.preset}${Shopify.formatMoney(total, window.Money_Filter)}`;
    });
    if(this.priceSetup) {
      this.priceSetup.innerHTML = `${this.priceSetup.dataset.preset}${Shopify.formatMoney(addFixed, window.Money_Filter)}`;
    }
  }
}
customElements.define("custom-volume-pricing", CustomVolumePricing);


// ── Tab Switcher ──────────────────────────────────────────────
class StartOrderTabs extends HTMLElement {
  connectedCallback() {
    this.tabs   = this.querySelectorAll("[data-tab-btn]");
    this.panels = this.querySelectorAll("[data-tab-panel]");
    this.tabs.forEach(btn =>
      btn.addEventListener("click", () => this.switchTab(btn.dataset.tabBtn))
    );
    this.switchTab(this.tabs[0]?.dataset.tabBtn);
  }

  switchTab(name) {
    this.tabs.forEach(btn => {
      btn.classList.toggle("is-active", btn.dataset.tabBtn === name);
      btn.setAttribute("aria-selected", String(btn.dataset.tabBtn === name));
    });
    this.panels.forEach(panel => {
      panel.hidden = panel.dataset.tabPanel !== name;
    });
  }
}
customElements.define("start-order-tabs", StartOrderTabs);

class InstantQuoteForm extends HTMLElement {
  connectedCallback() {
    this.qtyInput    = this.querySelector("[data-iq-qty]");
    this.typeSelect  = this.querySelector("[data-iq-type]");
    this.calcBtn     = this.querySelector("[data-iq-calc]");
    this.resultBlock = this.querySelector("[data-iq-result]");
    this.elTotal     = this.querySelector("[data-iq-out='total']");
    this.elSetup     = this.querySelector("[data-iq-out='setup']");
    this.elRun       = this.querySelector("[data-iq-out='run']");
    this.elTotalRun  = this.querySelector("[data-iq-out='total-run']");
    this.elEstimated = this.querySelector("[data-iq-out='estimated']");
    this.contactBtn  = this.querySelector("[data-iq-contact]");

    // Stored quote values for passing into popup hidden fields
    this._quoteSnapshot = {};

    this.calcBtn?.addEventListener("click",    () => this.calculate());
    this.contactBtn?.addEventListener("click", () => this._openPopup());

    this._buildPopup();
  }

  // ── Pricing logic ─────────────────────────────────────────────

  getUnitPrice(qty) {
    const isGuest   = this.dataset.isGuest === "true";
    const baseCents = parseInt(this.dataset.basePrice || 0);

    if (!isGuest) {
      const vpTable  = this.closest("start-order-tabs")?.querySelector(".vp-table");
      if (vpTable) {
        const qtyCells   = Array.from(vpTable.querySelectorAll(".vp-row--quantity .vp-qty"));
        const priceCells = Array.from(vpTable.querySelectorAll(".vp-row--standard .vp-single-price"));
        let matchIndex   = 0;
        qtyCells.forEach((cell, i) => {
          if (qty >= parseInt(cell.dataset.qty || 0)) matchIndex = i;
        });
        return parseInt(priceCells[matchIndex]?.dataset.singlePrice || baseCents);
      }
      return baseCents;
    }

    // Guest: apply CMS margin tiers
    const marginType = this.dataset.marginType || "pct";
    const tiers      = this._parseGuestTiers(this.dataset.tiers || "");
    const tier       = this._getBestTier(qty, tiers);
    return this._applyMargin(baseCents, marginType, tier.val);
  }

  calculate() {
    const qty = parseInt(this.qtyInput?.value || 0);
    if (!qty || qty <= 0) { this.qtyInput?.focus(); return; }

    const fmt         = (c) => Shopify.formatMoney(c, window.Money_Filter);
    const opt         = this.typeSelect?.options[this.typeSelect.selectedIndex];
    const isGuest     = opt?.dataset.guest === "true";
    const unitPrice   = this.getUnitPrice(qty);
    const totalBase   = unitPrice * qty;
    const setupCharge = parseInt(isGuest ? (opt?.dataset.fixed || 0) : (opt?.dataset.setup || 0));
    const runPerUnit  = parseInt(opt?.dataset.run || 0);
    const runTotal    = runPerUnit * qty;
    const estimated   = totalBase + setupCharge + runTotal;

    this.elTotal.textContent     = fmt(totalBase);
    this.elSetup.textContent     = fmt(setupCharge);
    this.elRun.textContent       = `${qty} x ${fmt(runPerUnit)}`;
    this.elTotalRun.textContent  = `${fmt(runTotal)}`;
    this.elEstimated.textContent = fmt(estimated);
    this.resultBlock.hidden      = false;

    // Snapshot for popup hidden fields
    this._quoteSnapshot = {
      totalPrice:    fmt(totalBase),
      setupCharges:  fmt(setupCharge),
      runCharges:    fmt(runTotal),
      totalCharges:  fmt(setupCharge + runTotal),
      estimatedTotal: fmt(estimated),
      setupType:     opt?.value || "",
      qty
    };
  }

  // ── Popup ─────────────────────────────────────────────────────

  _buildPopup() {
    // Avoid duplicates if connectedCallback fires more than once
    if (document.getElementById("iq-contact-popup")) return;

    const overlay = document.createElement("div");
    overlay.id    = "iq-contact-popup";
    overlay.className = "popup";
    overlay.style.display = "none";
    overlay.innerHTML = `
      <div class="popup-content">
        <button type="button" class="popup-close" id="iq-popup-close">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
          <path d="M18.36 6.64a1 1 0 0 0-1.41 0L12 11.59 7.05 6.64a1 1 0 1 0-1.41 1.41L10.59 13l-4.95 4.95a1 1 0 1 0 1.41 1.41L12 14.41l4.95 4.95a1 1 0 0 0 1.41-1.41L13.41 13l4.95-4.95a1 1 0 0 0 0-1.41z"></path>
        </svg>
        </button>

        <form id="iq-contact-form" class="tr-ready-made-form contact" autocomplete="off" novalidate>
        <div class="field">
          <input type="text"  name="full_name"       class="field__input tr-quote-form-field" placeholder="Full Name"             required>
          </div>
      <div class="field">
          <input type="email" name="email"           class="field__input tr-quote-form-field" placeholder="Email"                 required>
          </div>
      <div class="field">
          <input type="text"  name="company"         class="field__input tr-quote-form-field" placeholder="Company">
          </div>
      <div class="field">
          <input type="tel"   name="number"          class="field__input tr-quote-form-field" placeholder="Phone Number">
          </div>
      <div class="field">
          <textarea           name="additional_info" class="field__input tr-quote-form-field" placeholder="Additional Information"></textarea>
</div>
          <!-- Hidden quote fields -->
          <input type="hidden" name="total_price"    id="iq-hidden-total-price">
          <input type="hidden" name="setup_charges"  id="iq-hidden-setup-charges">
          <input type="hidden" name="run_charges"    id="iq-hidden-run-charges">
          <input type="hidden" name="total_charges"  id="iq-hidden-total-charges">
          <input type="hidden" name="estimated_total" id="iq-hidden-estimated-total">
          <input type="hidden" name="setup_type"     id="iq-hidden-setup-type">
          <input type="hidden" name="quantity"       id="iq-hidden-quantity">

          <button type="submit" class="popup-submit button button--primary">Submit</button>
        </form>

        <!-- Thank you state (hidden initially) -->
        <div id="iq-thankyou" style="display:none">
          <div class="tr-thanks-flex-main">
            <div class="thanks-icon-tr">
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="21" viewBox="0 0 14 21" fill="none">
                <path d="M4.63132 13.1786L1.54946 9.75802L0.5 10.9146L4.63132 15.5L13.5 5.6566L12.4579 4.5L4.63132 13.1786Z" fill="black"/>
              </svg>
            </div>
            <h4>
              ${this.dataset.thankyouHeading}
            </h4>
            <p class="iq-thx">
              ${this.dataset.thankyouContent}
            </p>
          </div>
        </div>
      </div>`;

    document.body.appendChild(overlay);

    // Close button
    overlay.querySelector("#iq-popup-close").addEventListener("click", () => this._closePopup());

    // Click outside to close
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) this._closePopup();
    });

    // Form submit
    overlay.querySelector("#iq-contact-form").addEventListener("submit", (e) => {
      e.preventDefault();
      this._submitForm(e.target);
    });

    this._popup = overlay;
  }

  _openPopup() {
    if (!this._popup) return;

    // Inject snapshot values into hidden fields
    const s = this._quoteSnapshot;
    this._setHidden("iq-hidden-total-price",    s.totalPrice    || "");
    this._setHidden("iq-hidden-setup-charges",  s.setupCharges  || "");
    this._setHidden("iq-hidden-run-charges",    s.runCharges    || "");
    this._setHidden("iq-hidden-total-charges",  s.totalCharges  || "");
    this._setHidden("iq-hidden-estimated-total",s.estimatedTotal|| "");
    this._setHidden("iq-hidden-setup-type",     s.setupType     || "");
    this._setHidden("iq-hidden-quantity",       s.qty           || "");

    // Reset form + thank-you state
    this._popup.querySelector("#iq-contact-form").style.display  = "block";
    this._popup.querySelector("#iq-thankyou").style.display      = "none";
    this._popup.querySelector("#iq-contact-form").reset();

    this._popup.style.display = "flex";
    document.documentElement.classList.add("tr-locked");
    document.body.classList.add("tr-locked");
  }

  _closePopup() {
    if (!this._popup) return;
    this._popup.style.display = "none";
    document.documentElement.classList.remove("tr-locked");
    document.body.classList.remove("tr-locked");
  }

  _setHidden(id, value) {
    const el = document.getElementById(id);
    if (el) el.value = value;
  }

  // async _submitForm(form) {
  //   const data      = Object.fromEntries(new FormData(form).entries());
  //   const submitBtn = form.querySelector("[type='submit']");

  //   submitBtn.disabled = true;
  //   submitBtn.textContent = "Sending…";

  //   const brevoKey  = this.dataset.brevoKey
  //                     || "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";

  //   const htmlContent = `
  //     <p><strong>Full Name:</strong> ${data.full_name}</p>
  //     <p><strong>Email:</strong> ${data.email}</p>
  //     <p><strong>Company:</strong> ${data.company || "—"}</p>
  //     <p><strong>Phone Number:</strong> ${data.number || "—"}</p>
  //     <p><strong>Additional Information:</strong> ${data.additional_info || "—"}</p>
  //     <hr>
  //     <p><strong>Setup Type:</strong> ${data.setup_type}</p>
  //     <p><strong>Quantity:</strong> ${data.quantity}</p>
  //     <p><strong>Total Price:</strong> ${data.total_price}</p>
  //     <p><strong>Setup Charges:</strong> ${data.setup_charges}</p>
  //     <p><strong>Run Charges:</strong> ${data.run_charges}</p>
  //     <p><strong>Total Charges:</strong> ${data.total_charges}</p>
  //     <p><strong>Estimated Total:</strong> ${data.estimated_total}</p>
  //   `;

  //   try {
  //     const res = await fetch("https://api.brevo.com/v3/smtp/email", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "api-key": "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",
  //       },
  //       body: JSON.stringify({
  //         sender:      { name: "Bugatti Wholesale", email: "noreply@bugattiwholesale.shop" },
  //         to:          [{ email: data.email }],
  //         subject:     "Instant Quote",
  //         htmlContent
  //       })
  //     });

  //     if (res.ok) {
  //       form.style.display = "none";
  //       this._popup.querySelector("#iq-thankyou").style.display = "block";
  //     } else {
  //       const err = await res.json();
  //       console.error("Brevo error:", err);
  //       alert("Failed to submit. Please try again.");
  //       submitBtn.disabled     = false;
  //       submitBtn.textContent  = "Submit";
  //     }
  //   } catch (err) {
  //     console.error("Network error:", err);
  //     alert("An error occurred. Please try again.");
  //     submitBtn.disabled    = false;
  //     submitBtn.textContent = "Submit";
  //   }
  // }

  async _submitForm(form) {
    const data      = Object.fromEntries(new FormData(form).entries());
    const submitBtn = form.querySelector("[type='submit']");

    submitBtn.disabled = true;
    submitBtn.textContent = "Sending…";

    const apiKey  = "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";
    const sender  = { name: "Bugatti Wholesale", email: "noreply@bugattiwholesale.shop" };
    const adminEmail = this.dataset.adminEmail || "hello@teamrhinoltd.com"; // set via data-admin-email="..." on the element

    const userEmail = data.email;
    console.log("userEmail000", userEmail);
    const userName  = data.full_name || "Valued Customer";

    // Shared quote detail rows
    const quoteRows = `
      <ul>
        <li><strong>Setup Type:</strong> ${data.setup_type}</li>
        <li><strong>Quantity:</strong> ${data.quantity}</li>
        <li><strong>Total Price:</strong> ${data.total_price}</li>
        <li><strong>Setup Charges:</strong> ${data.setup_charges}</li>
        <li><strong>Run Charges:</strong> ${data.run_charges}</li>
        <li><strong>Total Charges:</strong> ${data.total_charges}</li>
        <li><strong>Estimated Total:</strong> ${data.estimated_total}</li>
      </ul>`;

    // ── Email 1: Customer confirmation ───────────────────────────
    const customerPayload = {
      sender,
      to: [{ email: userEmail, name: userName }],
      subject: "Your Instant Quote Estimation",
      htmlContent: `
        <html><body>
          <h2>Hello ${userName},</h2>
          <p>Thank you for requesting a quote. Here are your estimated details:</p>
          ${quoteRows}
          <p>Our team will review this and reach out to you shortly!</p>
        </body></html>`
    };

    // ── Email 2: Admin notification ──────────────────────────────
    const adminPayload = {
      sender: { name: "Quote Engine", email: sender.email },
      to: [{ email: adminEmail, name: "Store Admin" }],
      replyTo: { email: userEmail, name: userName }, // Reply goes straight to customer
      subject: `NEW QUOTE REQUEST - ${userName}`,
      htmlContent: `
        <html><body>
          <h2>New Quote Submission Details</h2>
          <p><strong>Customer Name:</strong> ${userName}</p>
          <p><strong>Customer Email:</strong> ${userEmail}</p>
          <p><strong>Company:</strong> ${data.company || "—"}</p>
          <p><strong>Phone:</strong> ${data.number || "—"}</p>
          <p><strong>Additional Info:</strong> ${data.additional_info || "—"}</p>
          <hr>
          <h3>Quote Breakdown:</h3>
          ${quoteRows}
        </body></html>`
    };

    try {
      const url = "https://api.brevo.com/v3/smtp/email";
      const headers = {
        "Content-Type": "application/json",
        "api-key": apiKey
      };

      // Fire both requests simultaneously
      const [customerRes, adminRes] = await Promise.all([
        fetch(url, { method: "POST", headers, body: JSON.stringify(customerPayload) }),
        fetch(url, { method: "POST", headers, body: JSON.stringify(adminPayload) })
      ]);

      if (customerRes.ok && adminRes.ok) {
        form.style.display = "none";
        this._popup.querySelector("#iq-thankyou").style.display = "block";
      } else {
        if (!customerRes.ok) console.error("Customer email failed:", await customerRes.text().catch(() => ""));
        if (!adminRes.ok)    console.error("Admin email failed:",    await adminRes.text().catch(() => ""));
        alert("Failed to submit. Please try again.");
        submitBtn.disabled    = false;
        submitBtn.textContent = "Submit";
      }
    } catch (err) {
      console.error("Network error:", err);
      alert("An error occurred. Please try again.");
      submitBtn.disabled    = false;
      submitBtn.textContent = "Submit";
    }
  }

  // ── Tier utilities ────────────────────────────────────────────

  _parseGuestTiers(raw) {
    if (!raw) return [];
    const unescaped = raw.replace(/&amp;/g, "&").replace(/&#39;/g, "'");
    return unescaped.split("||").map(seg => {
      const parts = seg.trim().split(/\s+/).filter(Boolean);
      return { qty: parseInt(parts[0]) || 0, val: parseFloat(parts[1]) || 0 };
    }).filter(t => t.qty >= 0).sort((a, b) => a.qty - b.qty);
  }

  _getBestTier(qty, tiers) {
    let match = tiers[0] || { qty: 0, val: 0 };
    for (const t of tiers) { if (qty >= t.qty) match = t; }
    return match;
  }

  _applyMargin(baseCents, marginType, marginVal) {
    if (marginType === "pct") return Math.round(baseCents * (1 - marginVal / 100));
    return Math.max(0, baseCents - Math.round(marginVal * 100));
  }
}

customElements.define("instant-quote-form", InstantQuoteForm);


function soLockPage() {
    document.documentElement.classList.add('tr-locked');
    document.body.classList.add('tr-locked');
  }
  function soUnlockPage() {
    document.documentElement.classList.remove('tr-locked');
    document.body.classList.remove('tr-locked');
  }

  function soScrollToBottom(popupEl) {
    setTimeout(() => {
      popupEl.scrollTop = popupEl.scrollHeight;
    }, 300);
  }

  // ─────────────────────────────────────────────────────────────────────────────
  // StartOrderPopup
  // Owns: open / close, step visibility, journey tracking, back-nav (#stepatr),
  //       "go to step 3" event bridge, "show success" event.
  // ─────────────────────────────────────────────────────────────────────────────
  class StartOrderPopup extends HTMLElement {
    connectedCallback() {
      this._popup = this.querySelector('#startOrderPopup');
      this._content = this.querySelector('.start-order-popup-content');
      this._step1 = this.querySelector('#step1');
      this._step2rm = this.querySelector('#step2-readyMade');
      this._step2p = this.querySelector('#step2-personalized');
      this._step3 = this.querySelector('#step3');
      this._step4 = this.querySelector('#step4-success');
      this._feedback = this.querySelector('#emailFeedback');
      this._journey = ''; // 'readyMade' | 'personalized'

      // ── Open button (outside this element, so delegate via ID) ──
      document.getElementById('startOrderBtn')?.addEventListener('click', () => this._open());

      // ── Close buttons ──
      this.querySelectorAll('.start-order-close-popup').forEach((btn) =>
        btn.addEventListener('click', () => this._close())
      );

      // ── Step-1 journey buttons ──
      this.querySelector('[data-action="go-ready-made"]')?.addEventListener('click', () => this._goStep('readyMade'));
      this.querySelector('[data-action="go-personalized"]')?.addEventListener('click', () =>
        this._goStep('personalized')
      );

      // ── Step-3 back arrow (#stepatr) ──
      this.querySelector('#stepatr')?.addEventListener('click', () => {
        this._step3.style.display = 'none';
        if (this._journey === 'readyMade') this._step2rm.style.display = 'block';
        if (this._journey === 'personalized') this._step2p.style.display = 'block';
      });

      // ── Cross-element events ──
      // ready-made-form and personalized-form fire 'so:goto-step3'
      this.addEventListener('so:goto-step3', () => this._showStep3());
      // contact-form-step fires 'so:success' or 'so:error'
      this.addEventListener('so:success', () => this._showSuccess());
      this.addEventListener('so:error', (e) => this._showError(e.detail));

      // Scroll-to-bottom on any .tr-calculate-submit click inside the popup
      // this._content.addEventListener('click', (e) => {
      //   if (e.target.closest('.tr-calculate-submit')) soScrollToBottom(this._content);
      // });
    }

    _open() {
      this._showOnly(this._step1);
      this._popup.style.display = 'flex';
      soLockPage();
    }

    _close() {
      this._popup.style.display = 'none';
      soUnlockPage();
      this._showOnly(this._step1);
      if (this._feedback) this._feedback.innerText = '';
    }

    _goStep(journey) {
      this._journey = journey;
      this._step1.style.display = 'none';
      if (journey === 'readyMade') this._step2rm.style.display = 'block';
      if (journey === 'personalized') this._step2p.style.display = 'block';
    }

    _showStep3() {
      this._step2rm.style.display = 'none';
      this._step2p.style.display = 'none';
      this._step3.style.display = 'block';
    }

    _showSuccess() {
      const popup = this.closest('start-order-popup');
      const journey = popup?.journey || '';
      this._step4.setAttribute("class", '');
      this._step4.classList.add(journey);
      this._step3.style.display = 'none';
      this._step4.style.display = 'block';
    }

    _showError(msg) {
      if (!this._feedback) return;
      this._feedback.style.color = 'red';
      this._feedback.innerText = msg || 'An error occurred. Please try again.';
    }

    _showOnly(visibleEl) {
      [this._step1, this._step2rm, this._step2p, this._step3, this._step4].forEach((el) => {
        if (el) el.style.display = el === visibleEl ? 'block' : 'none';
      });
    }

    // Public getters consumed by child elements
    get journey() {
      return this._journey;
    }
    get popupContent() {
      return this._content;
    }
  }
  customElements.define('start-order-popup', StartOrderPopup);

  // ─────────────────────────────────────────────────────────────────────────────
  // ReadyMadeForm
  // Owns: per-variant totals, subtotal, submit-button enable/disable,
  //       collecting tableData, firing 'so:goto-step3' with payload.
  // ─────────────────────────────────────────────────────────────────────────────
  class ReadyMadeForm extends HTMLElement {
    connectedCallback() {
      this._currency = this.dataset.currency || 'CAD';
      this._form = this.querySelector('#variantForm');
      this._inputs = this.querySelectorAll('.variant-quantity');
      this._submitBtns = this.querySelectorAll('.tr-calulations-1, .tr-calulations-1ab');

      this._inputs.forEach((input) => {
        input.addEventListener('input', () => {
          this._updateVariantTotal(input);
          this._updateSubtotal();
          this._checkSubmitEnable();
        });
      });

      this._form.addEventListener('submit', (e) => {
        e.preventDefault();
        this._onSubmit();
      });

      this._updateSubtotal();
      this._checkSubmitEnable();
    }

    _getUnitPrice(input, qty) {
      const baseCents = parseInt(input.dataset.variantPrice) || 0;

      // Logged in user
      if (!this._isGuest) {
        const vpTable = document.querySelector('.vp-table:not(.vp-table--guest)');

        if (vpTable) {
          const qtyCells = Array.from(
            vpTable.querySelectorAll('.vp-row--quantity .vp-qty')
          );

          const priceCells = Array.from(
            vpTable.querySelectorAll('.vp-row--standard .vp-single-price')
          );

          let matchIndex = 0;

          qtyCells.forEach((cell, i) => {
            if (qty >= parseInt(cell.dataset.qty || 0)) {
              matchIndex = i;
            }
          });

          const matchedPrice = parseInt(
            priceCells[matchIndex]?.dataset.singlePrice
          );

          if (!isNaN(matchedPrice)) {
            return matchedPrice / 100; // dollars
          }
        }

        return baseCents / 100;
      }

      // Guest pricing
      const tiers = this._parseGuestTiers(this.dataset.tiers || '');
      const tier = this._getBestTier(qty, tiers);

      return (
        this._applyMargin(baseCents, this.dataset.marginType || 'pct', tier.val) /
        100
      );
    }

    _priceInCents(input) {
      return parseFloat(input.dataset.variantPrice) || 0; // already in cents from Shopify
    }

    _unitPrice(input) {
      return this._priceInCents(input) / 100;
    }

    _updateVariantTotal(input) {
      const qty = parseInt(input.value) || 0;
      const price = this._getUnitPrice(input, qty);
      const total = qty * price;
      const id = input.dataset.variantId;
      const cell_price = document.getElementById(`variant-price-${id}`);
      const cell = document.getElementById(`variant-total-${id}`);
      if (cell_price) cell_price.textContent = `$${this._fmt(price)} ${this._currency}`;
      if (cell) cell.textContent = `$${this._fmt(total)} ${this._currency}`;
    }

    _updateSubtotal() {
      // Sum only the desktop inputs (avoid double-counting mobile duplicates)
      const seen = new Set();
      let sub = 0;
      this._inputs = this.querySelectorAll('.variant-quantity');
      this._inputs.forEach((input) => {
        const id = input.dataset.variantId;
        if (seen.has(id)) return;
        seen.add(id);
        console.log("trueeeeeee", this._unitPrice(input), input, this._inputs.length);
        const qty = parseInt(input.value) || 0;
        sub += qty * this._getUnitPrice(input, qty);
      });
      const txt = `$${this._fmt(sub)} ${this._currency}`;
      ['sub-total', 'sub-total-2'].forEach((elId) => {
        const el = document.getElementById(elId);
        if (el) el.textContent = txt;
      });
    }

    _checkSubmitEnable() {
      const hasQty = Array.from(this._inputs).some((i) => (parseInt(i.value) || 0) > 0);
      this._submitBtns.forEach((btn) => {
        btn.disabled = !hasQty;
        btn.style.opacity = hasQty ? '1' : '0.6';
        btn.style.cursor = hasQty ? 'pointer' : 'not-allowed';
      });
    }

    _fmt(n) {
      return Number(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    _collectTableData() {
      const rows = Array.from(this._form.querySelectorAll('tbody tr'));
      return rows.map((row) => {
        const nameEl = row.querySelector('td:nth-child(1)');
        const priceEl = row.querySelector('td:nth-child(3)');
        const totalEl = row.querySelector('td:nth-child(4)');
        const imageEl = row.querySelector('.variant-image');

        // Prefer desktop qty; fall back to mobile qty
        const mobileInput = row.querySelector('.variant-quantity');
        let quantity = 0;
        if (mobileInput && parseInt(mobileInput.value) > 0) quantity = parseInt(mobileInput.value);

        return {
          variantName: nameEl ? nameEl.innerText.trim() : '',
          quantity,
          price: priceEl ? priceEl.innerText.trim() : '0',
          total: totalEl ? totalEl.innerText.trim() : '0',
          imageUrl: imageEl ? imageEl.getAttribute('src') : '',
        };
      });
    }

    _onSubmit() {
      const tableData = this._collectTableData();
      // Store on the root element so ContactFormStep can read it
      const popup = this.closest('start-order-popup');
      if (popup) popup._readyMadeData = tableData;
      this.dispatchEvent(new CustomEvent('so:goto-step3', { bubbles: true }));
    }
  }
  customElements.define('ready-made-form', ReadyMadeForm);

  // ─────────────────────────────────────────────────────────────────────────────
  // PersonalizedForm
  // Owns: calculate button, file upload UI, quote display, submit-to-step3.
  // ─────────────────────────────────────────────────────────────────────────────
  class PersonalizedForm extends HTMLElement {
    connectedCallback() {
      // data-product-price is in dollars (divided_by: 100 in Liquid) — keep for display only
      this._currency   = this.dataset.currency  || 'CAD';
      this._minQty     = parseInt(this.dataset.minQty) || 1;
      this._isGuest    = this.dataset.isGuest === 'true';
      this._marginType = this.dataset.marginType || 'pct';
      // data-base-price is raw Shopify cents (variant.price)
      this._baseCents  = parseInt(this.dataset.basePrice) || 0;

      this._form        = this.querySelector('#personalizedForm');
      this._qtyInput    = this.querySelector('[name="tr-quantity2"]');
      this._setupSelect = this.querySelector('[name="tr-setup-type2"]');
      this._fileInput   = this.querySelector('.tr-upload-field2');
      this._calcBtn     = this.querySelector('[data-action="calculate"]');
      this._submitBtn   = this.querySelector('[data-action="submit-personalized"]');
      this._quoteResult = this.querySelector('.tr-quote-result2');
      this._fileLabel   = this.querySelector('.file-input-label');
      this._removeLabel = this.querySelector('.tr-main-remove-label');

      this._personalizedData = {};

      this._buildFileUI();
      this._bindCalcButton();
      this._bindSubmitButton();
      this._bindQtyBlur();
    }

    // ── Volume pricing (mirrors InstantQuoteForm.getUnitPrice) ────────────────

    /**
     * Returns the correct unit price in CENTS for the given quantity,
     * applying volume-pricing rules for both guest and logged-in users.
     */
    _getUnitPrice(qty) {
      if (!this._isGuest) {
        // Logged-in: read from the VP table rendered on the page
        const vpTable = document.querySelector('.vp-table');
        if (vpTable) {
          const qtyCells   = Array.from(vpTable.querySelectorAll('.vp-row--quantity .vp-qty'));
          const priceCells = Array.from(vpTable.querySelectorAll('.vp-row--standard .vp-single-price'));
          let matchIndex = 0;
          qtyCells.forEach((cell, i) => {
            if (qty >= parseInt(cell.dataset.qty || 0)) matchIndex = i;
          });
          const matchedPrice = parseInt(priceCells[matchIndex]?.dataset.singlePrice);
          if (!isNaN(matchedPrice)) return matchedPrice;
        }
        // Fallback to base price if VP table is missing
        return this._baseCents;
      }

      // Guest: apply margin tiers
      const tiers = this._parseGuestTiers(this.dataset.tiers || '');
      const tier  = this._getBestTier(qty, tiers);
      return this._applyMargin(this._baseCents, this._marginType, tier.val);
    }

    _parseGuestTiers(raw) {
      if (!raw) return [];
      const unescaped = raw.replace(/&amp;/g, '&').replace(/&#39;/g, "'");
      return unescaped.split('||').map(seg => {
        const parts = seg.trim().split(/[\s,]+/).filter(Boolean);
        return { qty: parseInt(parts[0]) || 0, val: parseFloat(parts[1]) || 0 };
      }).filter(t => t.qty >= 0).sort((a, b) => a.qty - b.qty);
    }

    _getBestTier(qty, tiers) {
      let match = tiers[0] || { qty: 0, val: 0 };
      for (const t of tiers) {
        if (qty >= t.qty) match = t;
      }
      return match;
    }

    _applyMargin(baseCents, marginType, marginVal) {
      if (marginType === 'pct') {
        return Math.round(baseCents * (1 - marginVal / 100));
      }
      // fixed dollar amount → convert to cents
      return Math.max(0, baseCents - Math.round(marginVal * 100));
    }

    // ── File upload UI ────────────────────────────────────────────────────────
    _buildFileUI() {
      if (!this._fileInput || !this._removeLabel) return;

      const wrapper = document.createElement('div');
      wrapper.style.cssText = 'display:flex;align-items:center;margin-top:8px;';

      this._fileNameSpan = document.createElement('span');
      this._fileNameSpan.style.cssText = 'margin-right:10px;color:#000;font-size:14px;';

      this._removeBtn = document.createElement('button');
      this._removeBtn.innerText = '❌';
      this._removeBtn.style.cssText =
        'background:none;border:none;cursor:pointer;font-size:16px;color:#FF0000;display:none;';
      this._removeBtn.type = 'button';

      wrapper.appendChild(this._fileNameSpan);
      wrapper.appendChild(this._removeBtn);
      this._removeLabel.appendChild(wrapper);

      this._fileInput.addEventListener('change', () => this._onFileChange());
      this._removeBtn.addEventListener('click', () => this._clearFile());

      this._fileInput.addEventListener('change', () => {
        const allowed = ['eps', 'pdf', 'ai'];
        const file = this._fileInput.files[0];
        if (file) {
          const ext = file.name.split('.').pop().toLowerCase();
          if (!allowed.includes(ext)) {
            alert('Invalid file type! Please upload an EPS, PDF, or AI file.');
            this._fileInput.value = '';
            this._onFileChange();
          }
        }
      });

      this._checkCalcEnable();
    }

    _onFileChange() {
      const file = this._fileInput?.files[0];
      if (file) {
        this._fileNameSpan.innerText = file.name;
        this._removeBtn.style.display = 'inline-block';
        if (this._fileLabel) this._fileLabel.innerText = 'Replace image';
      } else {
        this._clearFile();
      }
      this._checkCalcEnable();
    }

    _clearFile() {
      if (this._fileInput)   this._fileInput.value = '';
      if (this._fileNameSpan) this._fileNameSpan.innerText = '';
      if (this._removeBtn)   this._removeBtn.style.display = 'none';
      if (this._fileLabel)   this._fileLabel.innerText = 'Upload image';
      this._checkCalcEnable();
    }

    _checkCalcEnable() {
      if (!this._calcBtn) return;
      const qty   = parseInt(this._qtyInput?.value || 0);
      const valid = qty > 0;
      this._calcBtn.disabled     = !valid;
      this._calcBtn.style.opacity = valid ? '1' : '0.6';
      this._calcBtn.style.cursor  = valid ? 'pointer' : 'not-allowed';
    }

    // ── Qty blur: enforce minimum ─────────────────────────────────────────────
    _bindQtyBlur() {
      if (!this._qtyInput) return;
      this._qtyInput.addEventListener('blur', () => {
        if (!this._qtyInput.value || parseInt(this._qtyInput.value) < this._minQty) {
          this._qtyInput.value = this._minQty;
        }
        this._checkCalcEnable();
      });
      this._qtyInput.addEventListener('input', () => this._checkCalcEnable());
    }

    // ── Calculate ─────────────────────────────────────────────────────────────
    _bindCalcButton() {
      this._calcBtn?.addEventListener('click', () => this._calculate());
    }

    _calculate() {
      const qty = parseInt(this._qtyInput?.value || 0);
      if (!qty || qty <= 0) { this._qtyInput?.focus(); return; }

      const opt       = this._setupSelect?.options[this._setupSelect.selectedIndex];
      const setupType = opt ? opt.value.trim() : '';
      const isGuest   = opt?.dataset.guest === 'true';

      // Mirror InstantQuoteForm.calculate() charge logic exactly
      const unitPriceCents = this._getUnitPrice(qty);                          // cents
      const totalBaseCents = unitPriceCents * qty;                             // cents
      const setupCharge    = parseInt(isGuest ? (opt?.dataset.fixed || 0) : (opt?.dataset.setup || 0)); // cents
      const runPerUnit     = parseInt(opt?.dataset.run || 0);                  // cents
      const runTotal       = runPerUnit * qty;                                 // cents
      const estimated      = totalBaseCents + setupCharge + runTotal;          // cents

      // Format for display (cents → dollars)
      const fmt = (cents) => `$${(cents / 100).toFixed(2)} ${this._currency}`;

      const q = this.querySelector.bind(this);
      q('.tr-total-price2').innerText      = `${Shopify.formatMoney(totalBaseCents, window.Money_Filter)} ${this._currency}`;
      q('.tr-setup-charges2').innerText    = `${Shopify.formatMoney(setupCharge, window.Money_Filter)} ${this._currency}`;
      q('.tr-run-charges2').innerText      = `${qty} x ${Shopify.formatMoney(runPerUnit, window.Money_Filter)} ${this._currency}`;
      q('.tr-total-run-charges2').innerText = `${Shopify.formatMoney(runTotal, window.Money_Filter)} ${this._currency}`;
      q('.tr-total-estimated2').innerText  = `${Shopify.formatMoney(estimated, window.Money_Filter)} ${this._currency}`;

      this._personalizedData = {
        qty,
        setupType,
        setupCharge:        setupCharge / 100,
        runCharge:          runPerUnit  / 100,
        totalRunCharges:    runTotal    / 100,
        totalPrice:         totalBaseCents / 100,
        totalEstimatedPrice: estimated  / 100,
      };

      if (this._quoteResult) this._quoteResult.style.display = 'flex';
    }

    // ── Submit → step 3 ───────────────────────────────────────────────────────
    _bindSubmitButton() {
      this._submitBtn?.addEventListener('click', () => this._onSubmit());
    }

    _onSubmit() {
      const file = this._fileInput?.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          this._personalizedData.imageBase64 = reader.result.split(',')[1];
          this._personalizedData.imageName   = file.name;
          this._proceed();
        };
        reader.onerror = () => {
          this.dispatchEvent(
            new CustomEvent('so:error', { bubbles: true, detail: 'Error processing the image. Please try again.' })
          );
        };
        reader.readAsDataURL(file);
      } else {
        this._personalizedData.imageBase64 = null;
        this._personalizedData.imageName   = null;
        this._proceed();
      }
    }

    _proceed() {
      const popup = this.closest('start-order-popup');
      if (popup) popup._personalizedData = this._personalizedData;
      this.dispatchEvent(new CustomEvent('so:goto-step3', { bubbles: true }));
    }
  }
  customElements.define('personalized-form', PersonalizedForm);

  // ─────────────────────────────────────────────────────────────────────────────
  // ContactFormStep
  // Owns: contact form submit → reads payload from StartOrderPopup →
  //       sends both Brevo emails → fires so:success or so:error.
  // ─────────────────────────────────────────────────────────────────────────────
  class ContactFormStep extends HTMLElement {
    connectedCallback() {
      this._form = this.querySelector('#contactForm');
      this._form?.addEventListener('submit', (e) => {
        e.preventDefault();
        this._onSubmit();
      });
    }

    async _onSubmit() {
      const popup = this.closest('start-order-popup');
      const journey = popup?.journey || '';

      const contactData = {
        name: this._form.name.value,
        email: this._form.email.value,
        phone: this._form.phone.value,
        message: this._form.message.value,
      };

      const isReadyMade = journey === 'readyMade';
      const tableData = popup?._readyMadeData || [];
      const persData = popup?._personalizedData || {};

      // Load email config from embedded JSON
      let cfg = {};
      try {
        cfg = JSON.parse(document.getElementById('so-email-config')?.textContent || '{}');
      } catch (_) {}

      const productPageURL = window.location.href;
      const brevoKey = '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';
      const adminEmail = popup?.dataset.adminEmail || '';

      // ── Admin email body ──
      const adminBody = `
        <h2>${isReadyMade ? 'Ready-Made Order Details' : 'Personalized Request Details'}</h2>
        ${isReadyMade ? this._adminTableHTML(tableData) : this._personalizedDetailsHTML(persData, cfg)}
        <h2>Contact Information</h2>
        <p><strong>Name:</strong> ${contactData.name}</p>
        <p><strong>Email:</strong> ${contactData.email}</p>
        <p><strong>Phone:</strong> ${contactData.phone}</p>
        <p><strong>Message:</strong> ${contactData.message}</p>
        <h2>Product Page URL</h2>
        <p><a href="${productPageURL}" target="_blank">${productPageURL}</a></p>
      `;

      // ── Customer email body ──
      const customerBody = this._buildCustomerEmail(isReadyMade, contactData, tableData, persData, cfg);

      // ── Brevo payloads ──
      const adminPayload = {
        sender: { name: 'Bugatti Wholesale', email: 'noreply@bugattiwholesale.shop' },
        to: [{ email: adminEmail }],
        subject: `New ${isReadyMade ? 'Ready-Made Order' : 'Personalized Request'} Submission`,
        htmlContent: adminBody,
      };

      if (!isReadyMade && persData.imageBase64) {
        adminPayload.attachment = [{ content: persData.imageBase64, name: persData.imageName }];
      }

      const customerPayload = {
        sender: { name: 'Bugatti Wholesale', email: 'noreply@bugattiwholesale.shop' },
        to: [{ email: contactData.email }],
        subject: `Your ${isReadyMade ? 'Order' : 'Request'} Has Been Received`,
        htmlContent: customerBody,
      };

      try {
        const [adminRes, custRes] = await Promise.all([
          this._sendBrevo(adminPayload, brevoKey),
          this._sendBrevo(customerPayload, brevoKey),
        ]);

        if (adminRes.ok && custRes.ok) {
          this.dispatchEvent(new CustomEvent('so:success', { bubbles: true }));
        } else {
          this.dispatchEvent(
            new CustomEvent('so:error', { bubbles: true, detail: 'Failed to send email. Please try again.' })
          );
        }
      } catch (err) {
        console.error('Email send error:', err);
        this.dispatchEvent(
          new CustomEvent('so:error', { bubbles: true, detail: 'An error occurred. Please try again.' })
        );
      }
    }

    _sendBrevo(payload, key) {
      return fetch('https://api.brevo.com/v3/smtp/email', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'api-key': key },
        body: JSON.stringify(payload),
      });
    }

    // ── Admin table (ready-made) ──────────────────────────────────────────────
    _adminTableHTML(tableData) {
      const rows = tableData
        .slice(0, -2)
        .map(
          (r) => `
            <tr>
              <td>${r.variantName}</td>
              <td>${r.quantity}</td>
              <td>${r.price}</td>
              <td>${r.total}</td>
            </tr>`
              )
              .join('');
            return `<table border="1" style="width:100%;">
            <tr><th>Variant</th><th>Quantity</th><th>Price</th><th>Total</th></tr>
            ${rows}
          </table>`;
    }

    // ── Personalized details (shared admin + customer) ────────────────────────
    _personalizedDetailsHTML(pd, cfg) {
      const popup = document.querySelector('start-order-popup');
      const productName = popup?.dataset.productTitle || '';
      const productURL = cfg.productUrl || '';
      const productImg = popup?.dataset.productImageEmail || '';
      const cur = popup?.dataset.productCurrency || 'CAD';
      const fmt = (n) => `$${(n || 0).toFixed(2)} ${cur}`;

      return `
        <div style="display:flex;align-items:center;gap:20px;margin-bottom:20px;">
          <div style="flex:1;width:25%;"><img src="${productImg}" alt="${productName}" width="100"/></div>
          <div style="flex:2;">
            <p><b><a href="${productURL}" target="_blank" style="color:#000;text-decoration:none;">${productName}</a></b></p>
            <p>Quantity: ${pd.qty || 0}</p>
            <p>Setup Type: ${pd.setupType || ''}</p>
            <p>Setup Charges: ${fmt(pd.setupCharge)}</p>
            <p>Run Charge: ${pd.qty || 0} x $${(pd.runCharge || 0).toFixed(2)} ${cur}</p>
            <p>Total Run Charges: ${fmt(pd.totalRunCharges)}</p>
            <p>Total Price: ${fmt(pd.totalPrice)}</p>
            <p><b>Estimated Total Price: ${fmt(pd.totalEstimatedPrice)}</b></p>
          </div>
        </div>`;
    }

    // ── Customer email body ───────────────────────────────────────────────────
    _buildCustomerEmail(isReadyMade, contactData, tableData, persData, cfg) {
      const popup = document.querySelector('start-order-popup');
      const cur = popup?.dataset.productCurrency || 'CAD';

      // Subtotal for ready-made
      let totalBlock = '';
      if (isReadyMade) {
        const filteredRows = tableData.slice(0, -3);
        const totalSum = filteredRows.reduce((s, r) => s + parseFloat(r.total.replace(/[^0-9.-]+/g, '') || 0), 0);
        const fmtTotal = new Intl.NumberFormat('en-CA', { style: 'currency', currency: 'CAD' }).format(totalSum);
        totalBlock = `<div style="margin-top:20px;text-align:right;font-size:16px;"><strong>Total:</strong> ${fmtTotal}</div>`;
      }

      // Ready-made line items
      const readyMadeRows = isReadyMade
        ? tableData
            .slice(0, -3)
            .map(
              (row) => `
                <div style="display:flex;margin:0;width:100%;gap:31px;color:rgba(0,0,0,1);justify-content:space-between;font:400 12px Graphik Trial,sans-serif;">
                  <div style="display:flex;gap:20px;align-items:center;">
                    <img src="${row.imageUrl}" alt="${
                        row.variantName
                      }" width="58" style="border-radius:5px;margin-right:15px;"/>
                    <div style="margin:auto 0;color:#000;font-size:12px;margin-right:45px;">
                      <a href="${cfg.productUrl || ''}" target="_blank" style="color:#000;text-decoration:none;">${
                        row.variantName
                      }</a> x ${row.quantity}
                    </div>
                  </div>
                  <div style="margin:auto 0;text-align:right;font-size:12px;margin-right:148px;">${row.price}</div>
                  <div style="margin:auto 0;text-align:right;font-size:12px;">${row.total}</div>
                </div>`
                    )
                    .join('')
                : '';

      // Collection grid
      const colItems = (cfg.collections || [])
        .map(
          (c) => `
            <div style="width:33%;text-align:center;">
              <img src="${c.img}" alt="${c.heading}" style="width:100%;" loading="lazy"/>
              <div style="color:#000;font:600 12px/13px Graphik Trial,sans-serif;text-align:left;">
                <a href="${c.link}" style="color:#000;text-decoration:none;" target="_blank">${c.heading}</a>
              </div>
              <div style="width:130px;color:#000;font-family:Graphik Trial,sans-serif;font-size:12px;font-weight:400;line-height:110%;text-align:left;margin-top:-20px;">${
                c.text || ''
              }</div>
            </div>`
            )
        .join('');

      const s = cfg.social || {};
      const socialIcons = Object.values(s)
        .map(
          (n) => `
          <a href="${n.link}" style="text-decoration:none;" target="_blank">
            <img src="${n.icon}" alt="${n.caption}" style="width:23.84px;max-height:23.84px;object-fit:contain;" loading="lazy"/>
          </a>`
        ).join('');

        return `
              <html><head></head><body style="margin:0;padding:0;font-family:'Graphik Trial',Arial,sans-serif;background:#fff;color:#000;">
              <div style="max-width:600px;margin:auto;background:#fff;padding:20px;">
                <div style="text-align:center;padding:20px 0;"><h2 style="margin:0;font-size:24px;text-transform:uppercase;">Bugatti Wholesale</h2></div>
                <img src="${
                  cfg.bannerUrl || ''
                }" alt="Bugatti Wholesale Header Banner" style="width:100%;height:auto;display:block;margin-bottom:20px;"/>
                <div style="padding:20px;">
                  <p style="text-transform:uppercase;font:400 16px/0.9 Graphik Trial,sans-serif;">Dear ${
                    contactData.name
                  },</p>
                  <p style="font-size:14px;line-height:1.5;">${cfg.thankYouText || ''}</p>
                  <h3 style="margin-top:30px;text-transform:uppercase;margin:40px 0 0;font:400 16px/0.9 Graphik Trial,sans-serif;">${
                    cfg.summaryHeading || ''
                  }</h3>
                  <div style="margin:16px 0 40px;font:400 14px/1.1 Graphik Trial,sans-serif;">${cfg.summaryText || ''}</div>
                  ${isReadyMade ? readyMadeRows : this._personalizedDetailsHTML(persData, cfg)}
                  ${totalBlock}
                </div>
                ${
                  isReadyMade
                    ? `<img src="${
                        cfg.bannerPersonalized || ''
                      }" alt="Promotional Banner" style="width:100%;height:auto;display:block;margin-top:20px;"/>`
                    : ''
                }
                <div style="margin:50px 0 0;height:1px;border-top:1px solid rgba(136,136,136,1);"></div>
                ${cfg.enableExplore ? `
                  <div style="color:#000;margin:60px 0 0;font:400 12px/13px Graphik Trial,sans-serif;width:100%;">
                    <span style="font-weight:600;font-size:14px;">${cfg.exploreHeading || ''}</span><br/><br/>${cfg.exploreText || ''}
                  </div>` : ''}
              ${cfg.enableExplore ? `<div style="display:flex;flex-wrap:wrap;justify-content:center;gap:20px;margin:40px 0;">${colItems}</div>` : ''}
              <div style="text-align:left;font:400 14px/15px Graphik Trial,sans-serif;color:#000;margin:40px 0;">${
                cfg.lastThankYou || ''
              }</div>
            </div>
            <div style="background-color:#000;margin:0 auto;max-width:600px;color:#fff;padding:35px 0 17px;font-family:'Graphik Trial',sans-serif;font-size:12px;text-align:center;">
              <div style="font-size:28px;line-height:0.9;margin:0 12px 0 13px;">Bugatti Wholesale</div>
              <div style="margin:20px 0 0;">Follow Us</div>
              <div style="margin:11px 0 0;">${socialIcons}</div>
              <div style="font-family:'Futura PT',sans-serif;margin:13px 0 0;">
                © 2025 Bugatti Wholesale. All Rights Reserved.
                <a href="https://771cf70f.sibforms.com/serve/MUIFAPlK-jOury-WfWMqRTYnDfX13xjHjPmjz7Iew_3UkgqRy2IJJQlZQ618utf08V4w1imnzrsxsRdgGFLF9zC3gGi5E5PySIX0wYw88xhgVAwMAgPWOlJX0VGH4XMYKEU8KkwJHGOATQnPQL-U2CBUS9q93wF-lkzN2-YEyXNtrpA3hV9oc8crU9ZFAXOQPp-5iA3X7k2CVRwy" style="color:#fff;text-decoration:underline;" target="_blank">Unsubscribe</a>
              </div>
            </div>
            </body></html>`;
    }
  }
  customElements.define('contact-form-step', ContactFormStep);